<template>
  <div class="page-content">
    <div class="title-h3">河南省交通事业发展中心内部处室</div>
    <div class="left">
      <div class="item active">
        <span class="name">处室 </span>
      </div>
      <div class="item" v-for="(item, i) in list" :key="i">
        <span class="name">{{ item.office_name }} </span>
      </div>
    </div>
    <div class="right">
      <div class="item active">
        <span class="name">负责人</span>
      </div>
      <div class="item" v-for="(item, i) in list" :key="i">
        <span class="name">{{ item.leader_name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getJiguanchushi } from "@/apis/zuzhijiagou";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getJiguanchushi();
  },
  methods: {
    async getJiguanchushi() {
      const { data } = await getJiguanchushi();
      this.list = data || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .title-h3 {
    font-size: 24px;
    font-size: var(--font-size-24);
    font-weight: 800;
    line-height: 33px;
    color: #0d7ce4;
    width: 100%;
    text-align: center;
    margin: 16px 0 30px;
  }
  .left,
  .right {
    .item {
      width: 353px;
      height: 40px;
      background: rgba(214, 235, 255, 0.39);
      border-radius: 10px;
      line-height: 40px;
      text-align: center;
      margin-bottom: 10px;
      position: relative;

      &.active {
        background-color: #0d7ce4;
        .name {
          color: #fff;
        }
      }
      .name {
        font-size: 18px;
        font-size: var(--font-size-18);
        font-weight: bold;
        line-height: 25px;
        color: #0d7ce4;
      }
    }
  }
  .left {
    margin-right: 100px;
    .item {
      &::after {
        content: "";
        position: absolute;
        height: 2px;
        background-color: #d6ebff;
        top: 50%;
        margin-top: -1px;
        left: 100%;
        width: 100px;
      }
      &.active::after {
        background-color: #fff;
      }
    }
  }
}
</style>
